import { apiClient } from "./client";

/** Một khoản đã thu và phần còn hoàn được của nó. */
export type RefundablePayment = {
  paymentId: string;
  method: string;
  paidVnd: number;
  alreadyRefundedVnd: number;
  refundableVnd: number;
  /** Nội dung chuyển khoản của giao dịch ngân hàng khớp khoản thu này, nếu biết. */
  sourceHint: string | null;
};

/** Hoá đơn có huỷ được không, và nếu được thì sẽ hoàn những khoản nào. */
export type CancellationCheck = {
  cancellable: boolean;
  reason: string | null;
  payments: RefundablePayment[];
};

export type Refund = {
  id: string;
  invoiceId: string;
  invoiceNumber: string;
  paymentMethod: string;
  amountVnd: number;
  status: "REQUESTED" | "EXECUTED" | "FAILED" | "CANCELLED";
  method: "GATEWAY" | "MANUAL";
  destination: string | null;
  reason: string | null;
  failureReason: string | null;
  createdAt: string;
  executedAt: string | null;
};

const BASE = "/v1/billing/refunds";

export const refundApi = {
  inspect: (invoiceId: string) =>
    apiClient.get<CancellationCheck>(`${BASE}/inspect/${invoiceId}`).then((r) => r.data),
  list: (status?: string) =>
    apiClient
      .get<Refund[]>(BASE, { params: status ? { status } : undefined })
      .then((r) => r.data),
  requestFullRefund: (invoiceId: string, reason: string) =>
    apiClient.post<string[]>(`${BASE}/invoice/${invoiceId}`, { reason }).then((r) => r.data),
  markExecuted: (id: string, evidence: string) =>
    apiClient.post<void>(`${BASE}/${id}/executed`, { evidence }),
  markFailed: (id: string, failureReason: string) =>
    apiClient.post<void>(`${BASE}/${id}/failed`, { failureReason }),
};

export const refundQueryKeys = {
  inspect: (invoiceId: string) => ["billing", "refunds", "inspect", invoiceId] as const,
  list: (status?: string) => ["billing", "refunds", "list", status ?? "all"] as const,
};
